import { toast } from 'react-toastify';

const recent = new Map<string, number>();
const DEDUPE_MS = 4000;

type ToastVariant = 'success' | 'info' | 'warning' | 'error';

/**
 * Show a toast at most once per message within a short window (duplicate
 * socket handlers / Strict Mode double-mount).
 */
export function toastOnce(
  message: string,
  type: ToastVariant = 'success',
  dedupeKey?: string
): void {
  const text = message.trim();
  if (!text) return;

  const now = Date.now();
  const keys = Array.from(
    new Set([dedupeKey?.trim(), text].filter((k): k is string => Boolean(k)))
  );
  if (keys.some((key) => now - (recent.get(key) ?? 0) < DEDUPE_MS)) {
    return;
  }
  keys.forEach((key) => recent.set(key, now));

  switch (type) {
    case 'info':
      toast.info(text);
      break;
    case 'warning':
      toast.warning(text);
      break;
    case 'error':
      toast.error(text);
      break;
    default:
      toast.success(text);
      break;
  }
}
